'use client';

import { useMemo } from 'react';
import { Modal } from '@/features/modal';
import TabBar from '@/features/tab-bar/tab-bar';
import { TabBarItem, TabSize, TabType } from '@/features/tab-bar/types';
import SafeHtml from '@/components/safe-html';
import ProductAttributesTable from './product-attributes/product-attributes-table';
import usePDPData from '../../_utils/use-pdp-data';
interface Props {
  isOpen: boolean;
  onClose: () => void;
  defaultToAttributes: boolean;
}
function DescriptionAttributesModal({
  isOpen,
  onClose,
  defaultToAttributes
}: Props) {
  const {
    data
  } = usePDPData();
  const description = data?.descriptionHtmlFa || '';
  const attributes = data?.attributes;
  const hasAttributes = !!attributes?.length;
  const hasDescription = !!description;
  const items = useMemo(() => {
    const tabs: TabBarItem[] = [];
    if (hasDescription) tabs.push({
      header: 'درباره محصول',
      body: <SafeHtml className='pdp-content' content={description} />
    });
    if (hasAttributes) {
      tabs.push({
        header: 'مشخصات محصول',
        body: <ProductAttributesTable attributes={attributes} />
      });
    }
    return tabs;
  }, [hasDescription, description, hasAttributes, attributes]);
  const modalTitle = useMemo(() => {
    if (hasAttributes && hasDescription) return 'توضیحات و مشخصات';
    if (hasAttributes) return 'مشخصات محصول';
    if (hasDescription) return 'درباره محصول';
    return '';
  }, [hasAttributes, hasDescription]);
  return <Modal isOpen={isOpen} handleClose={onClose} title={modalTitle} width='w-full lg:max-w-lg' bodyClassName='pt-2 px-2 pb-0' displayType='withTopBar' modalHash='detail-modal' className='h-[640px] max-h-[640px] min-h-[640px] pb-0' data-sentry-element="Modal" data-sentry-component="DescriptionAttributesModal" data-sentry-source-file="description-attributes-modal.tsx">
            <TabBar size={TabSize.Medium} items={items} type={TabType.PinkBox} headClassName='bg-white w-full overflow-hidden border-b border-border-gray-light rounded-none justify-normal' tabClassName='shadow-none border-none rounded-none text-body-14 w-fit flex-none' tabGroupClassName='flex flex-col h-full overflow-y-hidden p-0' bodyClassName='my-3 overflow-y-auto hide-scrollbar' defaultIndex={defaultToAttributes ? 1 : 0} data-sentry-element="TabBar" data-sentry-source-file="description-attributes-modal.tsx" />
        </Modal>;
}
export default DescriptionAttributesModal;